import { render, staticRenderFns } from "./account_xq.vue?vue&type=template&id=3b2922e6&scoped=true&"
import script from "./account_xq.vue?vue&type=script&lang=js&"
export * from "./account_xq.vue?vue&type=script&lang=js&"
import style0 from "./account_xq.vue?vue&type=style&index=0&id=3b2922e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2922e6",
  null
  
)

export default component.exports